var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58409 1.58409C3.6962 -0.528028 7.12053 -0.528028 9.23265 1.58409C11.3448 3.6962 11.3448 7.12065 9.23265 9.23276L5.40837 13.057L1.58409 9.23276C-0.528028 7.12065 -0.528028 3.6962 1.58409 1.58409V1.58409Z",
    fill: "url(#paint0_linear_35_2870)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40829 7.38678C6.50075 7.38678 7.38641 6.50118 7.38641 5.40872C7.38641 4.31626 6.50075 3.43066 5.40829 3.43066C4.31583 3.43066 3.43018 4.31626 3.43018 5.40872C3.43018 6.50118 4.31583 7.38678 5.40829 7.38678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_2870",
    x1: 2.86646,
    y1: 1.94156,
    x2: 8.18055,
    y2: 9.86313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7BFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464036,
    stopColor: "#34A5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDC44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8168,
    height: 13.057,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSini);
export default __webpack_public_path__ + "static/media/icon_sini.77c4ba52e224f0eda5843cdd18c32082.svg";
export { ForwardRef as ReactComponent };